import { createSvgComponent } from "../../icon/createSvgComponent";
import Home from "@core/__generated__/icon/figma/home.svg";
export default createSvgComponent(Home);